import React, { PureComponent, ReactNode } from 'react';

/* eslint frontbucket-patterns/no-old-dropdown-menu: "warn" */
import DropdownMenu from '@atlaskit/dropdown-menu';
import MoreIcon from '@atlaskit/icon/glyph/more';

type MoreMenuProps = {
  children: ReactNode;
  label: string;
};

export default class MoreMenu extends PureComponent<MoreMenuProps> {
  render() {
    const { children, label } = this.props;

    return (
      <DropdownMenu
        triggerType="button"
        triggerButtonProps={{
          iconBefore: <MoreIcon label={label} />,
          appearance: 'subtle',
        }}
        position="bottom right"
      >
        {children}
      </DropdownMenu>
    );
  }
}
